<template>
    <div class="container-fluid my-1">
        <div>
            <div :class="`mb-4 ps-2 pe-2 mb-3 ${image ? 'd-flex align-items-center' : ''}`">
                <div class="">
                    <label for="formFileMultiple" class="form-label">Imagem</label>
                    <input
                        ref="fileInput"
                        class="form-control"
                        type="file"
                        id="formFileMultiple"
                        @change="handleFileChange"
                    />
                    <p class="p-error-label">{{ errorLabel?.error && !image ? 'Esta faltando o campo da imagem!.' : ''}}</p>
                </div>
                <div
                    v-if="image && image.length > 0"
                    class="ms-4 mt-auto d-flex align-items-center justify-content-end flex-wrap"
                >
                    <img :src="image" alt="Preview image" height="60" width="60" style="object-fit: cover;" />

                </div>
            </div>
            <div class="ps-2 pe-2 mb-3">
                <label for="name" class="form-label"
                  >Nome do Sorteio</label
                >
                <input
                  v-model="namePrizeDraw"
                  type="text"
                  class="form-control"
                  id="name"
                  required
                  placeholder="Nome do Sorteio"
                />
                <p class="p-error-label">{{ errorLabel?.error && !namePrizeDraw ? 'Esta faltando o campo do nome!.' : ''}}</p>
            </div>
    

            <div class="d-flex justify-content-center mb-2">
                <button 
                    class="btn btn-dark me-1 col-6" 
                    @click="sendRequestPrizeDraw"
                    :disabled="!namePrizeDraw ? true : false"
                >
                Confirmar
                </button>
                <button
                    id="closeButtonEdit"
                    class="btn btn-outline-danger ms-1 col-6" 
                    data-bs-dismiss="modal" 
                    aria-label="Close"
                    :hidden="eventPrizeDrawClient?.type === 'PC'"
                    >
                    Cancelar
                </button>
            </div> 
        </div>
    </div>
</template>

<script>
import { ref, computed, onBeforeMount } from 'vue';
import store from "../../store";
import { createPrizedraw, editPrizedraw } from "../../http";

export default {
setup() {

    const eventPrizeDrawClient = computed(() => store.state.typeEventPrizeDrawClient);
    const namePrizeDraw = ref('');
    const image = ref(''); 
    const prizedraw = computed(() => store.state.prizedraw);
    
    const errorLabel = ref({
        namePrizeDraw: null,
        image: null,
        error: null
    })

    const sendRequestPrizeDraw = async () => {
        if(namePrizeDraw.value){
            const payload = {image: image.value, name: namePrizeDraw.value};

            if(eventPrizeDrawClient.value.type === 'PC'){
                await createPrizedraw(payload)
                    .then((data) => {
                        if(data?.message){
                            errorLabel.value.error = data?.message;
                            return;
                        }
                        store.commit('setPrizedraw', data);
                        namePrizeDraw.value = '';
                        image.value = '';
                        document.getElementById("closeButtonEdit").click();
                    });
            }else{
                await editPrizedraw(prizedraw.value?.id, payload)
                    .then((data)=>{
                        if(!data?.status){
                            errorLabel.value.error = data?.message;
                            return;
                        }
                        payload.id = prizedraw.value?.id;
                        store.commit('setPrizedraw', payload);
                        namePrizeDraw.value = '';
                        image.value = '';
                        document.getElementById("closeButtonEdit").click();
                    });
            }    
        }else{
            errorLabel.value.namePrizeDraw = "Campo obrigatório.";
            errorLabel.value.image = "Campo obrigatório.";
        }
    }

    const fileInput = ref(null);
    const handleFileChange = (event) => {
      image.value = null;
      errorLabel.value.image = null;

      const fileInput = event.target;
      const file = fileInput.files[0];
      const LIMIT_IMAGE = 200; // kb
      const size = +file["size"] / 1024;

      if (size > LIMIT_IMAGE) {
        fileInput.value = null;
        errorLabel.value.image =
          "Imagem muito grande, tamanho máximo permitido 200KB";
        return;
      }

      if (file && size <= LIMIT_IMAGE) {
        const reader = new FileReader();

        reader.onload = () => {
            // Make sure we have a proper data URL prefix
            const result = reader.result;
            if (!result.startsWith('data:image/')) {
                image.value = 'data:image/jpeg;base64,' + result.replace(/^data:.*?;base64,/, '');
            } else {
                image.value = result;
            }
        };
        reader.readAsDataURL(file);
      }
    };

    onBeforeMount(() => {
        namePrizeDraw.value = prizedraw.value?.name;
        image.value = prizedraw.value?.image;
    });

     return {
        namePrizeDraw,
        image,
        sendRequestPrizeDraw,
        prizedraw,
        handleFileChange,
        fileInput,
        eventPrizeDrawClient,
        errorLabel
  };
}
};
</script>

<style>
.p-error-label {
  font-size: 14px;
  color: red;
}
</style>